import { LoadingSpinner } from '@web_opxp/components';
import { ReactNode, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Selectors from '../selectors';
import { AchievementsActions } from '../slice';
import { IGlobalAchievement } from '../types';
import GlobalAchievementCard from './GlobalAchievementCard';
import './GlobalAchievementsList.scss';

function renderAchievementCard(achievement: IGlobalAchievement, index: number) {
  return (
    <div key={`${achievement.type}-${achievement.subType}-${index}`} className="global-achievement-cell">
      <GlobalAchievementCard type={achievement.type} subType={achievement.subType} />
    </div>
  );
}

// this is a list of global achievements on the dedicated achievements page
export default function GlobalAchievementsList() {
  const dispatch = useDispatch();
  const loading = useSelector(Selectors.isLoading);
  useEffect(() => {
    if (!loading) {
      return;
    }
    dispatch(AchievementsActions.loadAchievements());
  }, [dispatch, loading]);
  const reachedTiers = useSelector(Selectors.getMaxReachedTierGlobalAchievementsSortedByTier);
  const inProgressTiers = useSelector(Selectors.getGlobalAchievementsInProgress);
  const lockedTiers = useSelector(Selectors.getGlobalAchievementsLocked);
  const achievements: Array<ReactNode> = useMemo(() => {
    // 1. unlocked tiers of achievements achievements
    const reachedTiersCards = reachedTiers.map(renderAchievementCard);
    // find in progress achievements
    const inProgressCards = inProgressTiers.map(renderAchievementCard);
    // find locked achievements
    const lockedCards = lockedTiers.map(renderAchievementCard);
    return [...reachedTiersCards, ...inProgressCards, ...lockedCards];
  }, [reachedTiers, inProgressTiers, lockedTiers]);
  if (loading) {
    return <LoadingSpinner />;
  }
  return <div className="global-achievements-list">{achievements}</div>;
}
